<template>
  <a-card :bordered="false" v-if="userinfo">
    <a-tabs :default-active-key="defaultKey">
      <a-tab-pane key="1" tab="基本信息">
        <a-descriptions bordered>
          <a-descriptions-item label="昵称" :span="1">
            {{ userinfo.nickname ? userinfo.nickname : '未填写' }}
          </a-descriptions-item>

          <a-descriptions-item label="头像" :span="2">
            <img :src="userinfo.avatar ? userinfo.avatar : '/user.jpg'" />
          </a-descriptions-item>
          <a-descriptions-item label="邮箱" :span="1">
            {{ userinfo.email }}
          </a-descriptions-item>
          <a-descriptions-item label="性别" :span="1">
            {{ userinfo.sex | sexMap }}
          </a-descriptions-item>
          <a-descriptions-item label="联系电话" :span="1">
            {{ userinfo.phone }}
          </a-descriptions-item>
          <a-descriptions-item label="会员类型" :span="1">
            <a-badge :color="getTypeMap(userinfo.type).color" :text="getTypeMap(userinfo.type).value" />
          </a-descriptions-item>
          <a-descriptions-item label="账户余额" :span="1"> ￥{{ userinfo.balance }} </a-descriptions-item>
          <a-descriptions-item label="是否官方" :span="1">
            <span :style="{ color: userinfo.official === 1 ? 'green' : 'red' }">{{
              userinfo.official === 1 ? '是' : '否'
            }}</span>
          </a-descriptions-item>
          <a-descriptions-item label="状态" :span="3">
            {{ userinfo.state === 1 ? '正常' : '禁用' }}
          </a-descriptions-item>
          <a-descriptions-item label="上次登录IP" :span="3">
            {{ userinfo.ip }}
          </a-descriptions-item>
        </a-descriptions>
      </a-tab-pane>
      <a-tab-pane key="2" tab="认证信息">
        <template v-if="userinfo.real_auth !== 2">
          <a-descriptions bordered>
            <a-descriptions-item label="真实姓名" :span="1">
              {{ userinfo.real_name }}
            </a-descriptions-item>

            <a-descriptions-item label="身份证号" :span="2">
              {{ userinfo.real_id_card }}
            </a-descriptions-item>
            <a-descriptions-item label="证件照" :span="3">
              <viewer v-if="userinfo.real_img">
                <img :src="userinfo.real_img" width="120" height="120" />
              </viewer>
              <span v-else>未上传证件照</span>
            </a-descriptions-item>
            <a-descriptions-item label="认证状态" :span="3">
              <a-badge
                :color="getRealAuthMap(userinfo.real_auth).color"
                :text="getRealAuthMap(userinfo.real_auth).value"
              />
            </a-descriptions-item>
            <a-descriptions-item label="驳回原因" v-if="userinfo.real_auth === 4" :span="3">
              {{ userinfo.reject }}
            </a-descriptions-item>
          </a-descriptions>
          <template v-if="userinfo.real_auth === 3">
            <a-form
              :form="form"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 12 }"
              @submit="handleGetRealAuth"
            >
              <a-form-item label="申请认证">
                <a-radio-group
                  name="state"
                  v-decorator="[
                    'state',
                    {
                      rules: [{ required: true, message: '请选择分发用户' }],
                      initialValue: 1
                    }
                  ]"
                  @change="handleChange"
                >
                  <a-radio :value="1">
                    通过认证
                  </a-radio>
                  <a-radio :value="2">
                    驳回认证
                  </a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="驳回原因" v-if="selectKey === 2">
                <a-input
                  size="large"
                  type="text"
                  placeholder="驳回原因"
                  v-decorator="[
                    'reject',
                    {
                      rules: [{ required: true, message: '请填写驳回原因' }]
                    }
                  ]"
                ></a-input>
              </a-form-item>
              <a-form-item :wrapper-col="{ span: 13, offset: 7 }">
                <a-button type="primary" html-type="submit">
                  提交
                </a-button>
              </a-form-item>
            </a-form>
          </template>
        </template>
        <div class="account-center-detail" v-else>未申请认证</div>
      </a-tab-pane>
      <a-tab-pane key="3" tab="三方账号">
        <a-descriptions bordered>
          <a-descriptions-item label="oschina" v-if="userinfo.oschina_token">
            {{ userinfo.oschina_token }}
          </a-descriptions-item>
          <a-descriptions-item label="gitee" v-if="userinfo.gitee_token">
            {{ userinfo.gitee_token }}
          </a-descriptions-item>
          <a-descriptions-item label="github" v-if="userinfo.github_token">
            {{ userinfo.github_token }}
          </a-descriptions-item>
          <a-descriptions-item label="QQ" v-if="userinfo.qq_token">
            {{ userinfo.qq_token }}
          </a-descriptions-item>
          <a-descriptions-item label="Wechat" v-if="userinfo.wechat_token">
            {{ userinfo.wechat_token }}
          </a-descriptions-item>
        </a-descriptions>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import { requestPut } from '@/api/api'

export default {
    name: 'ModelDetail',
    props: {
        userinfo: {
            type: Object,
            default: () => null
        },
        defaultKey: {
            type: String,
            default: '1'
        },
        getTypeMap: {
            type: Function,
            required: true
        },
        getRealAuthMap: {
            type: Function,
            required: true
        }
    },
    data () {
        return {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 }
            },
            selectKey: 1,
            form: this.$form.createForm(this)
        }
    },
    mounted () {},
    methods: {
        /**
         * 选择认证是否通过
         * @param
         * status 1:通过 2:驳回
         * @jdy
         * @2020-10-16
         */
        handleChange (e) {
            this.selectKey = e.target.value
        },
        /**
         * 认证表单提交
         * @param
         * status 1:通过 2:驳回
         * reject 驳回原因
         * @jdy
         * @2020-10-16
         */
        handleGetRealAuth (e) {
            e.preventDefault()
            const {
                form: { validateFields }
            } = this
            validateFields((errors, values) => {
                if (!errors) {
                    requestPut('/members/auth/change/' + this.userinfo.id, values)
                        .then(res => {
                            this.$notification.success(res.msg)
                        })
                        .catch(err => console.log(err))
                }
            })
        },
        onOk () {
            return new Promise(resolve => {
                resolve(true)
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>

<style lang="less" scoped>
.account-center-detail {
    margin-top: 1rem;
    font-weight: bold;
    font-size: 1rem;
    color: #f50;
    margin-bottom: 1.25rem;
    text-align: center;
}
/deep/.ant-descriptions {
    margin-bottom: 1.25rem;
}
</style>
